<template>
    <div>
        <Row class="header">
            <div class="header_content">
                <div class="header_left">
                    <img @click="goMyUserCenter('6')" style="cursor:pointer;" src="../../assets/logo1.png"/>
                    <img @click="goMyUserCenter('6')" style="cursor:pointer;" src="../../assets/logo2.png"/>
                </div>
                <div class="header_right">
                    <div v-for="(item,index) in navList" :key="index">
                        <div v-if="item.type=='text'"
                             :class="item.children && item.children.length!=0 ? 'header_right_item dropDown_icon' : 'header_right_item' ">

                            <!--               非核验按钮           -->
                            <a @click="jumpRouter(item.path,item.temppath)" :class="item.path==pathName?'active':''"
                               v-if="item.type=='text' && item.name!='证书核验' ">{{item.name}}</a>

                            <!--               核验按钮           -->
                            <a @click="loginShowJump(item.name)" :class="item.path==pathName?'active':''"
                               v-if="item.type=='text' && item.name=='证书核验'">{{item.name}}</a>

                            <div v-if="item.top=='限时免费'" class="goPersonVip_right">
                                <img src="../../assets/xianshimianfei.png"/>
                                <p>限时免费</p>
                            </div>

                            <!--               下拉框            -->
                            <div v-if="item.children && item.children.length!=0" class="header_right_dropDown">
                                <p @click="jumpRouter(item2.path,item2.temppath)" v-for="(item2,index2) in item.children" class="header_right_dropDown_item">
                                    {{item2.name }}</p>
                            </div>

                        </div>
                        <input @click="loginShowJump(item.name)" :style="{'marginLeft':item.name=='登录/注册'?'30px':'0px'}"
                               v-if="item.name=='登录/注册'?item.type=='button'&&!showphoto:item.type=='button'"
                               type="button" :value="item.name"/>
                        <div class="header_right_language" v-if="item.name=='language'" @click="goEnglist(item.path)">En</div>
                    </div>
                    <div class="showphotow" v-show="showphoto">
                        <img @click="goUsercenter()"
                             style="width:42px;height:42px;margin-left:30px;cursor:pointer;border-radius:50%"
                             :src="avatarUrl?avatarUrl:userPhoto"/>
                        <img class="rotatesy" style="width:14px;height:14px;" src="@/assets/images/xiala-white.png"/>
                        <div class="showdiasy">
                            <p @click="goUserCenterFocus()">个人中心</p>
                            <p @click="goMyUserCenter('1')">我的存证</p>
                            <p @click="goMyUserCenter('2')">我的监测</p>
                            <p @click="goMyUserCenter('3')">我的取证</p>
                            <p @click="goMyUserCenter('4')">我的登记</p>
                            <p @click="goMyUserCenter('7')">我的预登记</p>
                            <p @click="goMyUserCenter('5')">法律服务列表</p>
                            <p @click="loginouts()">退出登录</p>
                        </div>
                    </div>
                </div>
            </div>
        </Row>
        <div v-if="showLoginOrRegistter">
            <login @fatherClose="closeLoginMethod" @childFn="parentFn"/>
        </div>
        <!-- 核验 -->
        <verifycode @fatherModal="fatherModal" v-show="showModal" :showIndex='showIndex'></verifycode>
    </div>
</template>

<script>
    import login from '@/views/login.vue'
    import Cookies from "js-cookie";
    import qs from 'qs';
    import {getStore, removeStore, setStore} from './../../libs/storage';
    import axios from 'axios';
    import verifycode from '@/views/vipClip/verification/verifyCode.vue'

    export default {
        name: "homeHeader",
        components: {
            login,
            verifycode
        },
        data() {
            return {
                userPhoto: require('@/assets/head.png'),
                showLoginOrRegistter: false,
                navList: [
                    {name: '首页', path: '/index.html', top: "", type: 'text'},
                    {
                        name: '关于我们',
                        path: '/aboutUs',
                        top: "",
                        type: 'text',
                        temppath: ''
                    },
                    // {
                    //     name: '资讯中心',
                    //     path: '/consultation-list',
                    //     top: "",
                    //     type: 'text',
                    //     temppath: ''
                    // },
                    {
                        name: '版权服务',
                        path: '',
                        top: "",
                        type: 'text',
                        temppath: '',
                        children: [
                            {
                                name: '产品包',
                                path: '/goods',
                                top: "",
                                type: 'text',
                                temppath: ''
                            },
                            // {
                            //     name: '个人VIP',
                            //     path: '/vipPersonal',
                            //     top: "",
                            //     type: 'text',
                            //     temppath: ''
                            // },
                            // {
                            //     name: '企业VIP',
                            //     path: '/vipEnterprise',
                            //     top: "",
                            //     type: 'text',
                            //     temppath: ''
                            // },
                            {
                                name: '存证登记',
                                path: '/regEvidence',
                                top: "",
                                type: 'text',
                                temppath: ''
                            }
                        ]
                    },
                    // {
                    //     name: '培训服务',
                    //     path: '',
                    //     top: "",
                    //     type: 'text',
                    //     temppath: ''
                    // },
                    // {
                    //     name: '产业集群直通车',
                    //     path: '',
                    //     top: "",
                    //     type: 'text',
                    //     temppath: ''
                    // },
                    {name: '证书核验', path: '4', top: "", type: 'text', temppath: ''},
                    {name: '30天试用会员', path: '/vipseven', top: "", type: 'text', temppath: ''},
                    {name: '登录/注册', path: '5', top: "", type: 'button'},
                    {name: 'language', path: '/english'}
                ],
                pathName: window.location.pathname,
                showphoto: false,
                tphoto: '',
                defaultphoto: require('./../../assets/head.png'),
                showModal: !1,
                showIndex: '0'
            }
        },
        computed: {
            avatarUrl: function () {
                return this.$store.state.avatarUrl
            }
        },
        watch: {
            $route(to, from) {
                let pathname = to.path;
                this.pathName = pathname
                this.showphoto = Cookies.get("userInfo") ? true : false;
                // if(Cookies.get("userInfo")){
                //   this.tphoto = JSON.parse(Cookies.get("userInfo")).photo;
                // }
            }
        },
        created() {
            this.showphoto = Cookies.get("userInfo") ? true : false;
            if (Cookies.get("userInfo")) {
                this.tphoto = JSON.parse(Cookies.get("userInfo")).photo;
            }
        },
        methods: {
            // 跳转英文首页
            goEnglist(path) {
                window.open(path, '_blank')
            },
            //ucenter通信
            callChild(jscode){

                // 传参并指定回调执行函数为onBack
                for(let j = 0, len = jscode.length; j < len; j++) {
                    let script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.src = jscode[j] + '&callback=onBack';
                    document.head.appendChild(script);
                }
                // let ifr = document.getElementById('main_login');
                // ifr.style.display = 'none';
                // setTimeout(function(){ top.location.reload(); }, 1000);
            },
            goMyUserCenter(number) {
                switch (number) {
                    case '1':
                        this.$router.push({
                            path: '/myExisting'
                        })
                        break;
                    case '2':
                        this.$router.push({
                            path: '/myMonitor'
                        })
                        break;
                    case '3':
                        this.$router.push({
                            path: '/myEvidence'
                        })
                        break;
                    case '4':
                        this.$router.push({
                            path: '/myDci'
                        })
                        break;
                    case '5':
                        this.$router.push({
                            path: '/legalOrder'
                        })
                        break;
                    case '6':
                        this.$router.push({
                            path: '/index.html'
                        })
                        break;
                  case '7':
                    this.$router.push({
                      path: '/myPre'
                    })
                    break;
                    default:
                        break;
                }
            },
            parentFn(payload) {
                this.showphoto = true
                this.tphoto = payload
            },
            jumpRouter(path, temppath) {
                if(path && path!=''){
                    this.pathName = path
                    // if(path=='/vipseven' || path=='/vipPersonal' || path=='/vipEnterprise'){
                    //   window.location.href = temppath
                    // }else{
                    this.$router.push({path: path})
                    // }
                    return
                }
                else if(temppath && temppath!=''){
                   window.location.href =  temppath;
                }

            },
            loginShowJump(name) {
                if (name == '登录/注册') {
                    this.showLoginOrRegistter = true
                } else if (name == '证书核验') {
                    this.showModal = !0;
                }
            },
            fatherModal() {
                let _this = this;
                _this.showModal = !1;
            },
            closeLoginMethod() {
                this.showLoginOrRegistter = false
            },
            goUsercenter() {
                this.$router.push({path: '/memberInfo'})
            },
            goUserCenterFocus() {
                this.$router.push({path: '/memberInfo'})
            },
            loginouts() {
                let _this = this
                let accessToken = getStore('accessToken');
                let username = '';
                if (Cookies.get("userInfo")) {
                    username = JSON.parse(Cookies.get("userInfo")).account ? JSON.parse(Cookies.get("userInfo")).account : '';
                }
                let params = {
                    username: username
                }
                axios({
                    method: 'post',
                    url: this.API_ROOT_UPLOAD + 'logout',
                    data: qs.stringify(params),
                    headers: {
                        'accessToken': accessToken
                    }
                }).then(function (response) {
                    console.log(response);
                    if (response.code == 200) {
                        //ucenter退出登录
                        let jscode = response.javascript;
                        _this.callChild(jscode);

                        Cookies.remove('accessToken', { domain: 'bqj.cn' });
                        Cookies.remove('userInfo');
                        // 清空打开的页面等数据
                        // removeStore('accessToken')
                        setStore('accessToken', '');
                        // localStorage.clear();
                        _this.showphoto = false
                        var midPagesa = "_empty" + "?time=" + new Date().getTime() / 500;
                        _this.$router.push(midPagesa);
                        _this.$router.push('/');
                        console.log('++++++++++++++++', _this.showphoto)

                    }
                })
                    .catch(function (err) {
                        console.log(err);
                    });
            }
        }
    };
</script>

<style lang="less">
    .header {
        height: 79px;
        background:rgba(255,255,255,1);
        min-width: 1334px;
        text-align: center;
        border-bottom: 1px solid #F1F1F1;
        .header_content {
            height: 80px;
            width: 1334px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0 auto;

            .header_left {
                img {
                    vertical-align: middle;
                }
            }

            .header_right {
                display: flex;
                justify-content: flex-end;
                align-items: center;

                .header_right_item {
                    position: relative;
                    height: 80px;
                    line-height: 80px;
                    margin: 0 10px;

                    // &.dropDown_icon a:after {
                    //     content: '';
                    //     padding-left: 12px;
                    //     height: 10px;
                    //     background: url(../../assets/images/header_dropDown.png) no-repeat left center;
                    //     background-size: 10px 10px;

                    // }


                    &:hover {

                        // &.dropDown_icon a:after {
                        //     content: '';
                        //     padding-left: 12px;
                        //     height: 10px;
                        //     background: url(../../assets/images/header_dropDown_active.png) no-repeat left center;
                        //     background-size: 10px 10px;
                        // }

                        &.dropDown_icon a {
                            color:rgba(18,18,16,1);
                        }
                        &.dropDown_icon a:before{
                            content:'';
                            background:#121210;
                            width:100%;
                            height: 1px;
                            position: absolute;
                            left:0;
                            bottom:20px;
                        }
                        .header_right_dropDown {
                            display: block;
                        }
                    }
                }

                a {
                    height: 20px;
                    font-size: 16px;
                    font-weight: 400;
                    color:rgba(18,16,0,0.7);
                    line-height: 24px;
                    /*margin-right: 50px;*/


                    &:hover {
                        /*color: #fff;*/
                        color:rgba(18,18,16,1);
                        &:before{
                            content:'';
                            background:#121210;
                            width:100%;
                            height: 1px;
                            position: absolute;
                            left:0;
                            bottom:20px;
                        }
                    }
                    
                }

                .active {
                    color:rgba(18,18,16,1);
                }
                .active:before{
                    content:'';
                    background:#121210;
                    width:100%;
                    height: 1px;
                    position: absolute;
                    left:0;
                    bottom:20px;
                }

                input {
                    width: 85px;
                    height: 34px;
                    background:rgba(255,255,255,1);
                    border:1px solid rgba(18,18,16,1);
                    font-size: 14px;
                    font-weight: 400;
                    color: #121210;
                    line-height: 34px;
                    cursor: pointer;
                    outline: none;
                }

                .header_right_dropDown {
                    position: absolute;
                    left: -19px;
                    box-sizing: border-box;
                    color: #A4A4A4;
                    font-size: 14px;
                    display: none;
                    z-index: 777;
                    width:108px;
                    height:172px;
                    background:rgba(255,255,255,1);
                    box-shadow:0px 5px 20px 0px rgba(0,0,0,0.1);

                    .header_right_dropDown_item {
                        width: 100%;
                        box-sizing: border-box;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        cursor: pointer;

                        &:hover {
                            color: #121210;
                        }
                    }
                    .header_right_dropDown_item:first-child{
                        margin-top:12px;
                    }
                }
                .header_right_language{
                    border: 1px solid #333333;
                    color: #333333;
                    margin-left: 20px;
                    padding: 0 2px;
                    &:hover{
                        color: #e82e31;
                        cursor: pointer;
                        border: 1px solid #e82e31;
                    }
                }

            }
        }

        .description {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.45);
            margin-top: 1vh;
        }

        .showphotow {
            position: relative;
            height: 80px;
            display: flex;
            align-items: center;
            .showdiasy {
                position: absolute;
                top:80px;
                left: 0px;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 20px 0px rgba(0,0,0,0.1);
                z-index: 777;
                width:108px;
                display: none;

                p {
                    height: 40px;
                    line-height: 40px;
                    cursor: pointer;
                    font-size:14px;
                    color: #A4A4A4;
                }

                p:hover {
                    color: #121210;
                }
            }

            .rotatesy {
                margin-left: 9px;
            }

            &:hover {
                .showdiasy {
                    display: block;
                }

                .rotatesy {
                    transform: rotate(180deg)
                }
            }
        }

        .goPersonVip_right {
            position: absolute;
            /*right: 0;*/
            /*top: -24px;*/
            right: -25px;
            top: -14px;

            p {
                position: absolute;
                /*top: 2px;*/
              top: -8px;
                left: 8px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(65, 65, 65, 1);
            }
        }
    }

</style>
